import { Box, styled } from "@mui/material";

export const TitleBox = styled(Box) (({theme}) => ({
    marginBottom: theme.spacing(3)
}));

export default TitleBox;
